import { AtActive as AT } from '/Assets/Js/Types%5EIndex.min.js?v=ceb741a6978ee514c1fbdf89f7c529e75aadf2bffd15f4f71b9875019c4ebcde';
let Constants = AT.Web.Constants;

document.addEventListener('DOMContentLoaded', () => {
    // 1. Safe extraction of AppConfig with fallbacks or optional chaining
    const config = window.AppConfig;
    if (!config) {
        Constants.Global.Debug(Constants.LogLevel.error, 'AppConfig is missing on window.');
        return;
    }

    const paramKey = 'maxDigitsForY';
    const url = window.location.pathname;
    const min = Number(config.minDigits ?? 1);
    const max = Number(config.maxDigits ?? 10);
    const numericCountUrl = String(config.numericCountUrl ?? '');

    let next = min;
    let isRestoringFromHistory = false;

    const puzzleForm = document.getElementById('puzzleForm') as HTMLFormElement;
    const maxDigitsInput = document.getElementById('MaxDigitsForY') as HTMLInputElement;
    const puzzleDisplayDiv = document.getElementById('puzzleInstructionsDisplay') as HTMLDivElement;
    const validationMessageElement = document.querySelector('.validation-message') as HTMLElement;
    const TextNextLink = document.querySelectorAll('.footer-text [data-text-class="nextLink"]') as NodeListOf<HTMLElement>;
    const TextNextDesc = document.querySelectorAll('.footer-text [data-text-class="nextDesc"]') as NodeListOf<HTMLElement>;

    const getValidDigits = (): number => {
        const val = parseInt(maxDigitsInput?.value ?? min.toString(), 10);
        return isNaN(val) || val < min || val > max ? min : val;
    };

    const getWrappedNext = (val: number) => (val >= max ? min : val + 1);

    const updateNextLinksAndDesc = async (displayNext: number, desc?: string) => {
        TextNextLink.forEach(el => el.textContent = `${url}?${paramKey}=${displayNext}`);
        try {
            if (!numericCountUrl) return '';

            const nextDesc = desc ??
                await fetch(`${numericCountUrl}?number=${displayNext}`)
                    .then(r => r.json())
                    .then(res => res.description);
            TextNextDesc.forEach(el => el.textContent = nextDesc);
            return nextDesc;
        } catch (err) {
            Constants.Global.Debug(Constants.LogLevel.warn, 'Failed to fetch next description', err);
            return '';
        }
    };

    // Initial setup
    next = getValidDigits();
    updateNextLinksAndDesc(getWrappedNext(next));

    // Handle next button clicks
    TextNextLink.forEach(el => {
        el.addEventListeners(['click'], event => {
            event.preventDefault();
            const newNext = getWrappedNext(next);
            maxDigitsInput.value = newNext.toString();
            maxDigitsInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
    });

    const generatePuzzle = async () => {
        const maxDigits = getValidDigits();

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ [paramKey]: maxDigits })
            });

            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
            const result = await response.json();

            const puzzleText = result.puzzleInstructions ?? '';
            const validationText = result.validationMessage ?? '';
            const maxDigitsForY = result.maxDigitsForY;

            if (puzzleDisplayDiv.querySelector('pre')) {
                puzzleDisplayDiv.querySelector('pre')!.innerHTML = puzzleText;
            }

            if (validationMessageElement) {
                validationMessageElement.innerHTML = validationText;
                validationMessageElement.style.display = validationText ? 'block' : 'none';
            }

            maxDigitsInput.value = maxDigitsForY.toString();

            const displayNext = getWrappedNext(maxDigitsForY);
            next = maxDigitsForY;

            const nextDesc = await updateNextLinksAndDesc(displayNext);

            // Only push new history if not navigating from popstate
            if (!isRestoringFromHistory) {
                const newUrl = new URL(window.location.href);
                newUrl.searchParams.set(paramKey, maxDigitsForY.toString());

                window.history.pushState({
                    digits: maxDigitsForY,
                    puzzle: puzzleText,
                    validation: validationText,
                    next,
                    nextDesc
                }, '', newUrl.href);
            }
        } catch (error) {
            Constants.Global.Debug(Constants.LogLevel.error, 'Error fetching new puzzle:', error);
            if (puzzleDisplayDiv) {
                puzzleDisplayDiv.innerHTML = `<p class="text-red-500">Failed to load puzzle: ${error instanceof Error ? error.message : String(error)}</p>`;
            }
            if (validationMessageElement) {
                validationMessageElement.innerHTML = `Error: ${error instanceof Error ? error.message : String(error)}`;
                validationMessageElement.style.display = 'block';
            }
        }
    };

    if (puzzleForm && maxDigitsInput && puzzleDisplayDiv) {
        puzzleForm.addEventListener('submit', e => {
            e.preventDefault();
            maxDigitsInput.dispatchEvent(new Event('change', { bubbles: true }));
        });

        maxDigitsInput.addEventListener('change', generatePuzzle);
    }

    // Handle browser back/forward navigation
    window.addEventListener('popstate', async (event) => {
        const state = event.state;
        if (!state) return;

        isRestoringFromHistory = true;

        maxDigitsInput.value = state.digits.toString();
        if (puzzleDisplayDiv.querySelector('pre')) {
            puzzleDisplayDiv.querySelector('pre')!.innerHTML = state.puzzle ?? '';
        }
        if (validationMessageElement) {
            validationMessageElement.innerHTML = state.validation ?? '';
            validationMessageElement.style.display = state.validation ? 'block' : 'none';
        }
        next = state.next;

        await updateNextLinksAndDesc(getWrappedNext(next), state.nextDesc);

        setTimeout(() => {
            isRestoringFromHistory = false;
        }, 50);
    });
});